import type { SVGProps } from "react";

/**
 * sound-fx, sound-effects
 * @category Sound & Music
 */
export default function IconSoundFx(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M5.35491 7.74999H3.75C2.64543 7.74999 1.75 8.64542 1.75 9.74999V14.25C1.75 15.3546 2.64543 16.25 3.75 16.25H5.35491C5.77433 16.25 6.18314 16.3818 6.52352 16.6269L11.4578 20.1796C11.7886 20.4178 12.25 20.1814 12.25 19.7739V4.22611C12.25 3.81856 11.7886 3.58221 11.4578 3.82034L6.52352 7.37306C6.18314 7.61813 5.77433 7.74999 5.35491 7.74999Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.0991 13.7902C17.2264 13.4033 17.7736 13.4033 17.9009 13.7902L18.282 14.949C18.3239 15.0763 18.4237 15.1761 18.551 15.218L19.7098 15.5991C20.0967 15.7264 20.0967 16.2736 19.7098 16.4009L18.551 16.782C18.4237 16.8239 18.3239 16.9237 18.282 17.051L17.9009 18.2098C17.7736 18.5967 17.2264 18.5967 17.0991 18.2098L16.718 17.051C16.6761 16.9237 16.5763 16.8239 16.449 16.782L15.2902 16.4009C14.9033 16.2736 14.9033 15.7264 15.2902 15.5991L16.449 15.218C16.5763 15.1761 16.6761 15.0763 16.718 14.949L17.0991 13.7902Z'
        fill='currentColor'
      />
      <path
        d='M18.9388 5.90622C19.1169 5.36459 19.8831 5.36459 20.0612 5.90622L20.5948 7.52857C20.6534 7.7068 20.7932 7.8466 20.9714 7.90522L22.5938 8.43877C23.1354 8.61691 23.1354 9.3831 22.5938 9.56123L20.9714 10.0948C20.7932 10.1534 20.6534 10.2932 20.5948 10.4714L20.0612 12.0938C19.8831 12.6354 19.1169 12.6354 18.9388 12.0938L18.4052 10.4714C18.3466 10.2932 18.2068 10.1534 18.0286 10.0948L16.4062 9.56123C15.8646 9.38309 15.8646 8.6169 16.4062 8.43877L18.0286 7.90522C18.2068 7.8466 18.3466 7.7068 18.4052 7.52856L18.9388 5.90622Z'
        fill='currentColor'
      />
    </svg>
  );
}
